import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { Body } from 'syf-component-library/ui/typography';
import { colors } from 'syf-component-library/defaultTheme';
import { Textfield } from 'syf-component-library/ui/atoms';
import { Label } from 'syf-component-library/ui/atoms/Textfield/subcomponents';
import query from 'syf-component-library/const/mediaQueries';
import Icon from '../../../../../icon';
import { FAR_CIRCLE_EXCLAMATION, FAS_CHECK_CIRCLE } from '../../../../../../const/icon-props';
const Container = styled(Inset) `
  display: flex;
  justify-content: center;
`;
const Wrapper = styled.div `
  width: 100%;
  max-width: 502px;
  @media ${query.lessThanSmall} {
    width: 90%;
  }
`;
const DescriptionContainer = styled(Inset) `
  display: flex;
`;
export const CustomTextField = styled(Textfield) `
  ${Label} {
    color: ${({ theme, error }) => error === '' ? theme.bodyText : colors.error};
  }
`;
export const CheckIcon = () => (_jsx(Inset, { top: "xsmall", left: "small", right: "small", children: _jsx(Icon, { title: "check circle icon", color: colors.success, icon: FAS_CHECK_CIRCLE, size: "lg" }) }));
const ErrorWrapper = styled(Inset) `
  display: flex;
  justify-content: center;
  align-items: flex-start;
  margin-top: 1.25px;
`;
export const DateOfBirthInputContainer = styled(Inset) `
  max-width: 340px;

  @media ${query.lessThanSmall} {
    max-width: 100%;
  }
`;
export const ErrorIcon = () => {
    return (_jsx(ErrorWrapper, { right: "xsmall", children: _jsx(Icon, { title: "circle error icon", color: colors.error, icon: FAR_CIRCLE_EXCLAMATION, size: "1x" }) }));
};
export const ContentWrapper = ({ children }) => (_jsx(Container, { top: "xxlarge", children: _jsx(Wrapper, { children: children }) }));
export const Description = ({ description }) => (_jsxs(DescriptionContainer, { bottom: "medium", children: [_jsx(CheckIcon, {}), _jsx(Body, { children: description })] }));
